/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { whatsAppAiReplyShow } from '../../axios/whatsAppAiReplyShow'
import type {
	WhatsAppAiReplyShowError,
	WhatsAppAiReplyShowPathParams,
	WhatsAppAiReplyShowResponse,
} from '../../types/WhatsAppAiReplyShow'

export const whatsAppAiReplyShowQueryKey = (candidateId: WhatsAppAiReplyShowPathParams['candidateId']) =>
	[{ url: '/candidates/:candidateId/whatsapp-ai', params: { candidateId } }] as const

export type WhatsAppAiReplyShowQueryKey = ReturnType<typeof whatsAppAiReplyShowQueryKey>

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiReplyController.php WhatsAppAiReplyController::show */
export function whatsAppAiReplyShowQueryOptions(
	candidateId: WhatsAppAiReplyShowPathParams['candidateId'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		WhatsAppAiReplyShowResponse,
		AxiosError<WhatsAppAiReplyShowError>,
		WhatsAppAiReplyShowResponse,
		WhatsAppAiReplyShowQueryKey
	>({
		queryKey: whatsAppAiReplyShowQueryKey(candidateId),
		queryFn: ({ signal }) => whatsAppAiReplyShow(candidateId, { signal, ...config }).then(res => res.data),
		enabled: !!candidateId,
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiReplyController.php WhatsAppAiReplyController::show */
export function useWhatsAppAiReplyShow<TSelectData = WhatsAppAiReplyShowResponse>(
	candidateId: WhatsAppAiReplyShowPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					WhatsAppAiReplyShowResponse,
					AxiosError<WhatsAppAiReplyShowError>,
					TSelectData,
					WhatsAppAiReplyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<WhatsAppAiReplyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...whatsAppAiReplyShowQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Campaign/Http/Controllers/WhatsAppAiReplyController.php WhatsAppAiReplyController::show */
export function useWhatsAppAiReplyShowSuspense<TSelectData = WhatsAppAiReplyShowResponse>(
	candidateId: WhatsAppAiReplyShowPathParams['candidateId'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					WhatsAppAiReplyShowResponse,
					AxiosError<WhatsAppAiReplyShowError>,
					TSelectData,
					WhatsAppAiReplyShowQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<WhatsAppAiReplyShowError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...whatsAppAiReplyShowQueryOptions(candidateId),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
